module.exports = __webpack_public_path__ + "d70d73df7c630bf917c8c1d1bb97aba2.png";